"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const models_1 = require("@osmosys/models");
const js_yaml_1 = require("js-yaml");
const react_1 = tslib_1.__importDefault(require("react"));
const react_use_1 = require("react-use");
const reactstrap_1 = require("reactstrap");
const reusables_1 = require("../../../comps/reusables");
const graphql_1 = require("../../../graphql");
const inputs_1 = require("../../../inputs");
const hooks_1 = require("../../../hooks");
exports.AppSettings = (props) => {
    const { appSettings } = props;
    const [showError, toggleError] = react_use_1.useToggle(false);
    const { currentUser } = hooks_1.useOsmosysContext();
    if (showError) {
        throw new Error('Testing error');
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(reusables_1.Form, { mutationProps: {
                mutation: graphql_1.updateAppSettings,
            }, formikProps: {
                initialValues: {
                    allowSignups: appSettings.allowSignups,
                    allowUsersToCreateWorkspaces: appSettings.allowUsersToCreateWorkspaces,
                    appUser: appSettings.appUser ? appSettings.appUser : null,
                    enableMagicLinks: appSettings.enableMagicLinks,
                    featureFlagOverrides: Object.assign(Object.assign({}, new models_1.FeatureFlags()), appSettings.featureFlagOverrides),
                    minifyOnCampaignSend: appSettings.minifyOnCampaignSend === true,
                    minifySettings: js_yaml_1.dump(appSettings.minifySettings || {}),
                    removeHideablesOnCampaignSend: appSettings.removeHideablesOnCampaignSend,
                    removeOsysTagsOnCampaignSend: appSettings.removeOsysTagsOnCampaignSend,
                    requireWorkspacesToHavePaymentMethod: appSettings.requireWorkspacesToHavePaymentMethod,
                },
            }, valuesToVariables: values => ({
                data: Object.assign(Object.assign({}, values), { appUser: values.appUser ? values.appUser.id : null, featureFlagOverrides: values.featureFlagOverrides, minifySettings: js_yaml_1.load(values.minifySettings) }),
            }), showBottomToolbar: true }, formikProps => {
            var _a;
            return (react_1.default.createElement(reusables_1.SmallCenteredLayout, null,
                react_1.default.createElement("h3", { className: "text-center p-2" }, "Feature flags"),
                react_1.default.createElement("div", { className: "d-flex w-100 my-2 flex-column" },
                    react_1.default.createElement("div", { className: "flex-row d-flex w-100" },
                        react_1.default.createElement("div", { className: "flex-grow-1" },
                            react_1.default.createElement("p", null,
                                react_1.default.createElement("strong", null, "Feature flag overrides"),
                                ' '))),
                    react_1.default.createElement(reusables_1.FeatureFlagsForm, { featureFlagOverrides: formikProps.values.featureFlagOverrides, onChange: featureFlags => {
                            formikProps.setFieldValue('featureFlagOverrides', featureFlags);
                        } })),
                react_1.default.createElement("h3", { className: "text-center p-2" }, "Post Processing"),
                react_1.default.createElement(reusables_1.FormGroup, { name: "removeHideablesOnCampaignSend", label: "Remove hidden hideable blocks on campaign sends", type: "checkbox" }),
                react_1.default.createElement(reusables_1.FormGroup, { name: "removeOsysTagsOnCampaignSend", label: "Remove OSYS tags on campaign sends", type: "checkbox" }),
                react_1.default.createElement(reusables_1.FormGroup, { name: "minifyOnCampaignSend", label: "Minify HTML on campaign sends", type: "checkbox" }),
                formikProps.values.minifyOnCampaignSend && (react_1.default.createElement("div", { style: { height: 500 }, className: "d-flex w-100 my-2 flex-column" },
                    react_1.default.createElement("div", { className: "flex-row d-flex w-100" },
                        react_1.default.createElement("div", { className: "flex-grow-1" },
                            react_1.default.createElement("p", null,
                                react_1.default.createElement("strong", null, "Minification settings"),
                                ' ')),
                        react_1.default.createElement("div", { className: "text-right ml-auto flex-grow-1" },
                            react_1.default.createElement("a", { href: "https://www.npmjs.com/package/html-minifier" },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faExternalLink, size: "sm", className: "mr-1" }),
                                ' ',
                                "Docs"))),
                    react_1.default.createElement(reusables_1.CodeEditor, { onChange: val => {
                            formikProps.setFieldValue('minifySettings', val);
                        }, value: formikProps.values.minifySettings, focusOnMount: false }))),
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                react_1.default.createElement(reactstrap_1.Alert, { color: "danger" }, "Please do not make any changes below unless you know what you are doing."),
                react_1.default.createElement("br", null),
                react_1.default.createElement("h3", { className: "text-center p-2 mt-2" }, "Access"),
                react_1.default.createElement(reusables_1.FormGroup, { name: "allowSignups", label: "Allow signups", type: "checkbox" }),
                react_1.default.createElement(reusables_1.FormGroup, { name: "enableMagicLinks", label: "Enable magic links ", type: "checkbox" }),
                react_1.default.createElement("h3", { className: "text-center p-2 mt-2" }, "Workspaces"),
                react_1.default.createElement(reusables_1.FormGroup, { name: "allowUsersToCreateWorkspaces", label: "Allow users who signup to create workspaces (Not yet implemented)", type: "checkbox", disabled: true }),
                react_1.default.createElement(reusables_1.FormGroup, { name: "requireWorkspacesToHavePaymentMethod", label: "Require all workspaces to have a payment method on file (Not yet implemented)", type: "checkbox", disabled: true }),
                react_1.default.createElement("h3", { className: "text-center p-2 mt-2" }, "Configuration"),
                react_1.default.createElement(inputs_1.OsmosysResourceSelectBox
                // name="appUser"
                , { 
                    // name="appUser"
                    selectFirstIfNoValue: false, currentUserId: (_a = currentUser) === null || _a === void 0 ? void 0 : _a.id, resource: "user", labelOverride: "App user (should be an NPC)", label: true, value: currentUser, boldLabel: true }),
                react_1.default.createElement("h3", { className: "text-center p-2 mt-2" }, "Debug"),
                react_1.default.createElement(reactstrap_1.Button, { onClick: () => {
                        toggleError();
                    } }, "Trigger an error")));
        })));
};
exports.default = exports.AppSettings;
//# sourceMappingURL=AppSettings.js.map